import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useHistoricoContext } from "../../../Context/Historico";
import { CadastrarCustasController } from "../../../Controllers/Geral/LancamentoCustas/LancamentoCustasController";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { IParcelasCustasRequest } from "../../../Interfaces/Geral/LancamentoCustas/LancamentoCustasInterface";
import { InserirValores } from "./EtapaInserirValores";
import { Detalhes } from "./EtapaDetalhes";
import { TipodeCustas } from "./EtapaTipodeCustas";
import { RegistrarCustas } from "./EtapaRegistrarCustas";
import { CAP } from "./EtapaCAP";
import { createWizard } from "../../Utils/Wizard";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
interface ILancamentoCustasProps {
    empresa: string;
    obra: string;
    venda: string;

    idCaso: number;
    idTipoCaso: number;

    setShow(show: boolean): void;
}

const inserirStepInputs = ["Valor"] as Array<keyof IParcelasCustasRequest>;
const detalhesStepInputs = [
    "Origem",
    "Frequencia",
    "PlanoIdx",
    "Tipo",
    "Reajuste",
    "PadraoCobranca",
] as Array<keyof IParcelasCustasRequest>;
const capStepInputs = [
    "CapPrincipal",
    "CapCorrecao",
    "CapDesconto",
    "CapDescontoCusta",
    "CapJurosAtraso",
    "CapRepasse",
    "CapAcrescimo",
    "CapCorrecaoAtraso",
    "CapDescontoAntecipacao",
    "CapJuros",
    "CapMulta",
    "CapTaxaBoleto",
] as Array<keyof IParcelasCustasRequest["cap"]>;

const {
    useWizard,
    Wizard,
    WizardStep,
    WizardControl,
    WizardControlStep,
    WizardControlStepButton,
} = createWizard(["Inserir", "Detalhes", "Tipos", "CAP", "Registrar"]);

export default function LancamentoCustas(props: ILancamentoCustasProps) {
    const formLancamentoCusta = useForm<IParcelasCustasRequest>();
    const { handleSubmit, reset, trigger, formState } = formLancamentoCusta;

    const inserirIsValid = inserirStepInputs.every(
        (input) => !formState.errors[input]
    );
    const detalhesIsValid = detalhesStepInputs.every(
        (input) => !formState.errors[input]
    );
    const capIsValid = capStepInputs.every(
        (input) => !formState.errors.cap?.[input]
    );

    const { ReloadHistorico } = useHistoricoContext();
    const { execute: CadastrarCustas, loading } = useAsyncCallback(
        CadastrarCustasController
    );

    const [showCap] = useState(false);

    const wizard = useWizard();

    function handleFormASubmit(formData: IParcelasCustasRequest) {
        const nullCap = {
            CapAcrescimo: null,
            CapCorrecao: null,
            CapCorrecaoAtraso: null,
            CapDesconto: null,
            CapDescontoAntecipacao: null,
            CapDescontoCusta: null,
            CapJuros: null,
            CapJurosAtraso: null,
            CapMulta: null,
            CapPrincipal: null,
            CapRepasse: null,
            CapTaxaBoleto: null,
        };
        const cap = showCap ? formData.cap : nullCap;
        CadastrarCustas(props.idCaso, props.idTipoCaso, {
            ...formData,
            cap,
            Empresa: Number(props.empresa),
            Obra: props.obra,
            Venda: Number(props.venda),
        }).then(() => {
            reset({
                cap: nullCap,
            });
            ReloadHistorico?.();
            props.setShow(false);
        });
    }
    return (
        <div className="py-5 px-2">
            <FormProvider {...formLancamentoCusta}>
                <form
                    typeof="button"
                    onSubmit={handleSubmit(handleFormASubmit)}
                >
                    <Wizard
                        {...wizard}
                        stepInfo={{
                            Inserir: {
                                title: "Inserir Valores",
                                valid: inserirIsValid,
                            },
                            Detalhes: {
                                title: "Detalhes do lançamento",
                                valid: detalhesIsValid,
                            },
                            Tipos: {
                                title: "Tipos de Custas",
                            },
                            CAP: {
                                title: "Adicionar CAP",
                                valid: capIsValid,
                            },
                            Registrar: {
                                title: "Registrar Custas",
                            },
                        }}
                    >
                        <WizardStep stepKey="Inserir">
                            <InserirValores />
                        </WizardStep>
                        <WizardStep stepKey="Detalhes">
                            <Detalhes
                                empresa={props.empresa}
                                obra={props.obra}
                                venda={props.venda}
                                idCaso={props.idCaso}
                                idTipoCaso={props.idTipoCaso}
                            />
                        </WizardStep>
                        <WizardStep stepKey="Tipos">
                            <TipodeCustas />
                        </WizardStep>
                        <WizardStep stepKey="CAP">
                            <CAP />
                        </WizardStep>
                        <WizardStep stepKey="Registrar">
                            <RegistrarCustas />
                        </WizardStep>

                        <WizardControl onClick={trigger}>
                            <WizardControlStep step="Registrar">
                                <WizardControlStepButton />
                                <WizardControlStepButton
                                    disabled={
                                        loading ||
                                        !(
                                            inserirIsValid &&
                                            detalhesIsValid &&
                                            capIsValid
                                        )
                                    }
                                    icon={faEdit}
                                    buttonType="submit"
                                    loading={loading}
                                >
                                    Registrar Custas
                                </WizardControlStepButton>
                            </WizardControlStep>
                        </WizardControl>
                    </Wizard>
                </form>
            </FormProvider>
        </div>
    );
}
